import type { Theme } from './light'

/**
 * Template C Dark – Modern & Dezent (Dark Mode)
 * 
 * Dunkle Variante des Modern-Themes mit dezent-modernen Akzenten
 * und angepassten Kontrasten für Dark Mode
 */
export const modernDarkTheme: Theme = {
  name: 'modernDark',
  colors: {
    // Primärfarben basierend auf UI-Styleguide
    primary: '#a5d7cc',
    primaryLight: '#c2f1eb',
    primaryDark: '#85c7c6',
    
    // Sekundärfarben basierend auf UI-Styleguide
    secondary: '#7b9d7c',
    secondaryDark: '#5e7e5f',
    
    // Status-Farben basierend auf UI-Styleguide
    success: '#7b9d7c',
    danger: '#ea1f0e',
    warning: '#e6b86b',
    info: '#85c7c6',
    
    // Hintergrundfarben
    background: '#1d1d1b',
    backgroundLight: '#2a2a2a',
    backgroundSecondary: '#2a2a2a',
    backgroundTertiary: '#252523', // Nur minimal heller als background für Tabellen-Header
    backgroundDark: '#0f0f0f',
    surface: '#2a2a2a',
    
    // Textfarben
    text: '#ffffff',
    textLight: '#c2f1eb',
    textDark: '#ffffff',
    textOnPrimary: '#1d1d1b',
    
    // UI-Elemente
    border: '#57747a',
    hover: '#343a40',
    focus: 'rgba(165, 215, 204, 0.25)',
    
    // Schatten
    shadowColor: 'rgba(0, 0, 0, 0.5)',
  },
  
  // Schatten-Definitionen
  shadows: {
    sm: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.3)',
    md: '0 0.5rem 1rem rgba(0, 0, 0, 0.4)',
    lg: '0 1rem 3rem rgba(0, 0, 0, 0.5)',
  },
  
  // Weitere Theme-spezifische Eigenschaften
  properties: {
    headerHeight: '60px',
    sidebarWidth: '250px',
    borderRadius: {
      sm: '0.375rem',
      md: '0.5rem',
      lg: '0.75rem',
    },
    transitions: {
      fast: '150ms ease-in-out',
      normal: '300ms ease-in-out',
      slow: '500ms ease-in-out',
    },
    fonts: {
      family: '"Inter", "Roboto", "Helvetica Neue", sans-serif',
      sizes: {
        h1: '2rem', // 32px
        h2: '1.5rem', // 24px
        h3: '1.125rem', // 18px
        body: '1rem', // 16px
        small: '0.875rem', // 14px
      },
      weights: {
        regular: '400',
        medium: '500',
        semibold: '600',
        bold: '700'
      }
    },
    buttons: {
      primary: {
        background: '#a5d7cc',
        text: '#1d1d1b',
        hover: '#c2f1eb'
      },
      secondary: {
        background: '#7b9d7c',
        text: '#ffffff',
        hover: '#5e7e5f'
      },
      neutral: {
        background: '#57747a',
        text: '#ffffff',
        hover: '#496369'
      },
      success: {
        background: '#7b9d7c',
        text: '#ffffff',
        hover: '#5e7e5f'
      },
      warning: {
        background: '#e6b86b',
        text: '#1d1d1b',
        hover: '#e0d26f'
      },
      danger: {
        background: '#ea1f0e',
        text: '#ffffff',
        hover: '#cf7666'
      }
    },
    alerts: {
      info: {
        background: '#2a3c40',
        text: '#c2f1eb',
        icon: '#85c7c6'
      },
      success: {
        background: '#2c3c2d',
        text: '#acd7c8',
        icon: '#7b9d7c'
      },
      warning: {
        background: '#3c3824',
        text: '#e2c56c',
        icon: '#e0d26f'
      },
      danger: {
        background: '#3d1512',
        text: '#f6c6b8',
        icon: '#ea1f0e'
      }
    }
  },
}
